import { TaskInstanceActionComponentProps } from "./types";
import { SendDestinationEnvelopeForm } from "./SendDestinationEnvelopeForm";

export function DestinationPacketTaskAction({
  taskInstance,
  onClose,
}: TaskInstanceActionComponentProps) {
  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4 rounded-lg border border-border p-4 md:flex-row md:items-center md:justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
            {taskInstance.template_instance?.template?.name || ""}
          </p>
          <h3 className="text-xl font-semibold">
            {taskInstance.task?.title || "New Destination Form"}
          </h3>
          <p className="text-sm text-muted-foreground">
            Send destination envelope forms to customers.
          </p>
        </div>
      </div>

      <SendDestinationEnvelopeForm
        taskInstance={taskInstance}
        onSuccess={() => {
          onClose();
        }}
      />
    </div>
  );
}

